import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog } from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Alert/index.css';
import { useTranslation } from "react-i18next";
import Checkbox from '@material-ui/core/Checkbox';


const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
    font-size: 24px;
    font-weight: 600;
`

const MainContent = styled.div`
    p{
        padding: 0 20px;
        font-size: 17px;
        font-weight: 400;
    }
`;


const ButtonRow = styled.div`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 20px;
        button{
            padding: 7px 15px;
            outline: 0;
            border: 2px #838687 solid;
            background: #fff;
            font-size: 15px;
            cursor: pointer;
    }
    button+button{
        margin-left: 20px;
    }
    .confirm{
        border: 2px rgb(0,122,186) solid;
        background: rgb(0,122,186);
        color: #fff;
    }
`
const CheckBoxRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: -12px 0 0 10px;
`


export default function ConfirmationModal(props) {
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const [checkAll, setcheckAll] = useState(false)
    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                footerStyle={{ padding: '0px' }}
                cardStyle={{
                    marginBottom: '80px',
                    fontFamily: "'Proxima Nova',-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue','sans-serif'"
                }}>

                <ModalHeader>{props.title}</ModalHeader>
                {props?.topMsg ? <MainContent><p style={{ marginTop: 0 }}>{props.topMsg}</p></MainContent> : null}
                <MainContent><p>{props.body}</p></MainContent>
                {props.needcheck ? <CheckBoxRow>
                    <Checkbox 
                    id='check'
                        checked={checkAll ? checkAll : false}
                        color="primary"
                        onClick={e => { setcheckAll(!checkAll) }}
                        name="deviceRow" />
                    <label for="check" style={{marginTop: '0px'}}>{props.checktext}</label>
                </CheckBoxRow> : null}
                <ButtonRow>
                    {
                        (props.btnData || []).map((data, index) =>
                            <button
                                className={`${data.class}`}
                                key={index}
                                onClick={() => { props.fromConfirmationPopup({ btnData: data, checkAll: checkAll }); setcheckAll(false) }}
                            >
                                {data.innerTxt}
                            </button>
                        )
                    }
                </ButtonRow>
            </Dialog>
        </>
    )
}